__turbopack_context__.v({
  "compareSection": "AiInRecruitingCompareSection-module__efI4Ta__compareSection",
  "compareTitle": "AiInRecruitingCompareSection-module__efI4Ta__compareTitle",
  "subtitle": "AiInRecruitingCompareSection-module__efI4Ta__subtitle",
});
